import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service';
import { MaterialAllocationFilter, MaterialAllocation, MaterialAllocationDetails, uploadException,Region, userID } from "../../Models/MaterialAllocation/MaterialAllocation"
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component'
import { PagerService } from '../../Services/pager.service'
import { IDropdownSettings } from 'ng-multiselect-dropdown'
import { Documents } from '../../Models/AnnualRequirement/ExcelDocuments'
import * as XLSX from "xlsx"
import { e } from '@angular/core/src/render3';
import { ELEMENT_PROBE_PROVIDERS } from '@angular/platform-browser/src/dom/debug/ng_probe';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-material-allocation',
  templateUrl: './material-allocation.component.html',
  styleUrls: ['./material-allocation.component.css'],
  providers: [DatePipe]
})
export class MaterialAllocationComponent implements OnInit {
  @ViewChild('requirementStatus') requirementStatus;
  @ViewChild('JobNumber') JobNumber;
  @ViewChild('State') State;
  @ViewChild('year') year;

  userID: string;
  roleID: string;

  selectedRMHName: string = '';
  selectedJobType: string = '';
  selectedBrand: string = '';
  selectedCrop: string = '';
  selectedLanguage: string = '';
  selectedMonth: string = '';
  currentStatus: string;
  selectedJobNumber: string;
  selectedState: string;
  selectedYear: any = '';
  quantity:number;

  materialAllocationFilters: MaterialAllocationFilter = new MaterialAllocationFilter();
  materialAllocation: MaterialAllocation[] = [];// new MaterialAllocation();
  materialAllocationDetails: MaterialAllocationDetails[] = [];//FinalRequirementDetails[] = [];//new FinalRequirementDetails();
  loader: string = 'none';
  files: File[] = [];
  fileName: string = '';
  pageSetting: number = 10;
  pager: any = {};
  model: MaterialAllocationDetails[] = [];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  userName: string;
  Date = new Date();


  ascNumberSort: boolean = true;
  sortDirection: string = '';

  //Multiple dropdown select
  dropdownMonth = [];
  selectedItems = [];
  dropdownStatus = [];
  dropdownSettings: IDropdownSettings = {};
  dropdownCropSettings: IDropdownSettings = {};
  dropdownBrandSettings: IDropdownSettings = {};
  dropdownJobTypeSettings: IDropdownSettings = {};
  dropdownLanguageSettings: IDropdownSettings = {};
  dropdownRmhsSettings: IDropdownSettings = {};
  dropdownstatusSettings: IDropdownSettings = {};
  dropdownJobNumbersSetting: IDropdownSettings = {};
  dropdownstateSetting: IDropdownSettings = {};
  dropdownyearSetting: IDropdownSettings = {};

  //display of popup
  displayViewPanel: string = 'block';
  displayEditPanel: string = 'none';
  popJobNumber: string;
  popEstDel: string;
  popRMH: string;
  popLanguage: number;
  popState: string;
  popBrand: string;
  popJobType: string;
  popCrop: string;
  popFAQ: number;
  popName: string;
  popUserID: string;
  popDesg: string;
  popAQty: number;
  popStatus: number;
  popTotalremainingqty: number;
  popRequirmentID: number;
  hdnLimit: boolean = true;
  errorMessage: string;
  IsValidRole: boolean = false;
  selectCheck: boolean;
  TotalRemainingQuantity: number = 0;
  popRequirementType: number;
  popRegion:string;
  Region:Region[]=[];
  changeRegionFAQ:number;
  MIEMDOuserDetail:userID[]=[];
  accessdata:string='';// add by deepanshu 15 june 2023


  //upload excel
  document: Documents = new Documents();
  IsFileCorrect: boolean;
  arrayBuffer: any;
  filelist: any;
  displayUploadPanel: string = 'none';
  errorExcelUpload: uploadException[] = [];

  //Confirm Receipt
  confirmRequirementId: string = '';
  confirmJobNumber: string = '';

  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private router: Router, private datePipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.userName = localStorage.getItem('mcmt_userName');
    if (this.roleID == "42" || this.roleID == "76") {
      this.displayViewPanel = "block";
    }
  }
  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.MaterialAllocationfilter();
    this.bindMonthDropdown();
    this.bindDropdown();
    this.applySearchFilter();
    this.hdnLimit = true;
    this.ascNumberSort = true;
    this.sortDirection = '';
    this.errorExcelUpload=null;
  }
  onItemSelect(event: any, filter: string) {
    debugger;
    if (filter == "Month") {
      if (this.selectedMonth.length == 1)
        this.selectedMonth += ',';
      this.selectedMonth += event.item_id + ',';

    }
    if (filter == "RMH") {
      if (this.selectedRMHName.length > 0 && this.selectedRMHName.indexOf(",") == -1)
        this.selectedRMHName += ',';
      this.selectedRMHName += "'" + event.rMHCode + "'" + ',';

    }
    if (filter == "Crop") {
      if (this.selectedCrop.length > 0 && this.selectedCrop.indexOf(",") == -1)
        this.selectedCrop += ',';
      this.selectedCrop += event.cropID + ',';

    }
    if (filter == "Brand") {
      if (this.selectedBrand.length > 0 && this.selectedBrand.indexOf(",") == -1)
    
        this.selectedBrand += ',';
      // this.selectedBrand += "'" + event.brandName + "'" + ',';
      this.selectedBrand +=  event.brandName + ',';

    }
    if (filter == "Language") {
      if (this.selectedLanguage.length > 0 && this.selectedLanguage.indexOf(",") == -1)
        this.selectedLanguage += ',';
      this.selectedLanguage += event.languageID + ',';

    }
    if (filter == "Jobtype") {
      if (this.selectedJobType.length > 0 && this.selectedJobType.indexOf(",") == -1)
        this.selectedJobType += ',';
      this.selectedJobType += event.jobTypeID + ',';

    }
  }
  onSelectAll(event: any, filter: string) {

    if (filter == "Month") {
      this.selectedMonth = '';
      for (let item of event) {
        this.selectedMonth += item.item_id.toString() + ',';
      }

    }
    if (filter == "RMH") {
      this.selectedRMHName = '';
      for (let item of event) {
        this.selectedRMHName += "'" + item.rMHCode.toString() + "'" + ',';
      }

    }
    if (filter == "Crop") {
      this.selectedCrop = '';
      for (let item of event) {
        this.selectedCrop += item.cropID.toString() + ',';
      }

    }
    if (filter == "Brand") {
      this.selectedBrand = '';
      for (let item of event) {
        this.selectedBrand += "'" + item.brandName.toString() + "'" + ',';
      }

    }
    if (filter == "Language") {
      this.selectedLanguage = '';
      for (let item of event) {
        this.selectedLanguage += item.languageID.toString() + ',';
      }

    }
    if (filter == "Jobtype") {
      this.selectedJobType = '';
      for (let item of event) {
        this.selectedJobType += item.jobTypeID.toString() + ',';
      }

    }
  }
  deSelectAll(event: any, filter: string) {
    if (filter == "Month")
      this.selectedMonth = '';
    if (filter == "RMH")
      this.selectedRMHName = '';
    if (filter == "Jobtype")
      this.selectedJobType = '';
    if (filter == "Brand")
      this.selectedBrand = '';
    if (filter == "Crop")
      this.selectedCrop = '';
    if (filter == "Language")
      this.selectedLanguage = '';
  }
  unSelect(event: any, filter: string) {
    switch (filter) {
      case "Month":
        {
          if (this.selectedMonth.indexOf(event.item_id + ',') != -1) {
            this.selectedMonth = this.selectedMonth.replace(event.item_id + ',', '');
          }
          else {
            this.selectedMonth = this.selectedMonth.replace(event.item_id, '');
          }
          break;
        }
      case "RMH":
        {
          if (this.selectedRMHName.indexOf("'" + event.rMHCode + "'" + ',') != -1) {
            this.selectedRMHName = this.selectedRMHName.replace("'" + event.rMHCode + "'" + ",", '');
          }
          else {
            this.selectedRMHName = this.selectedMonth.replace("'" + event.rMHCode + "'", '');
          }
          break;
        }
      case "Jobtype":
        {
          if (this.selectedJobType.indexOf(event.jobTypeID + ',') != -1) {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID + ',', '');
          }
          else {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID, '');
          }
          break;
        }
      case "Brand":
        {
          if (this.selectedBrand.indexOf("'" + event.brandName + "'" + ',') != -1) {
            this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'" + ",", '');
          }
          else {
            this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'", '');
          }
          break;
        }
      case "Crop":
        {
          if (this.selectedCrop.indexOf(event.cropID + ',') != -1) {
            this.selectedCrop = this.selectedCrop.replace(event.cropID + ',', '');
          }
          else {
            this.selectedCrop = this.selectedCrop.replace(event.cropID, '');
          }
          break;
        }
      case "Language":
        {
          if (this.selectedLanguage.indexOf(event.languageID + ',') != -1) {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID + ',', '');
          }
          else {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID, '');
          }
          break;
        }
      default:
    }
  }
  bindMonthDropdown() {
    this.dropdownMonth = [
      { item_id: 1, item_text: 'January' },
      { item_id: 2, item_text: 'February' },
      { item_id: 3, item_text: 'March' },
      { item_id: 4, item_text: 'April' },
      { item_id: 5, item_text: 'May' },
      { item_id: 6, item_text: 'June' },
      { item_id: 7, item_text: 'July' },
      { item_id: 8, item_text: 'August' },
      { item_id: 9, item_text: 'September' },
      { item_id: 10, item_text: 'October' },
      { item_id: 11, item_text: 'November' },
      { item_id: 12, item_text: 'December' }
    ];
    this.dropdownStatus = [
      // { item_id: 3, item_text: 'Vendor Finalization Pending' },
      // { item_id: 4, item_text: 'PO Issuance Pending' },
      // { item_id: 5, item_text: 'Artwork Awaited' },
       { item_id: 6, item_text: 'Material Allocation To Be Received' },
      { item_id: 7, item_text: 'Material Allocation Received' },
      { item_id: 8, item_text: 'Dispatched by Printer' },
      { item_id: 9, item_text: 'Material To Be Received At WH' },
      { item_id: 10, item_text: 'Dispatch To Field In Process' },
      { item_id: 11, item_text: 'Field Team Confirmation Pending' },
      { item_id: 12, item_text: 'Received by Field team' }
    ];

    this.dropdownstatusSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
  }
  bindDropdown() {
    this.dropdownCropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownBrandSettings = {
      singleSelection: false,
      idField: 'brandName',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownJobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownLanguageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownRmhsSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownJobNumbersSetting = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownstateSetting = {
      singleSelection: false,
      idField: 'stateID',
      textField: 'stateName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownyearSetting = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false,
      enableCheckAll: false
    };
  }
  applySearchFilter() {
    this.GetMaterialAllocationScreen();
  }
  MaterialAllocationfilter() {
    this.loader = 'block';
    this.mcPlanningMaterialService.getMaterialAllocationFilter()
      .subscribe((responsedata: any) => {
        if (responsedata.status == true) {
          debugger;
          this.materialAllocationFilters = responsedata.data;
          this.accessdata=responsedata.data.access[0].access; //add by deepanshu 4 june
         // alert(this.accessdata);//add by deepanshu 4 june
          this.onCurrentRequirementYearSelected(this.materialAllocationFilters.year)
          this.loader = 'none';
        }
        else {
          this.toastr.error('No data available in filters');
          this.loader = 'none';
        }
      })
  }

  public onCurrentRequirementYearSelected(item: any) {
    class YearItemList{
      id: number;
      text: string;
  }
    let requiredItem: YearItemList[] = [];
    var obj = {
      id : item[0].currentrequirementYear,
      text: item[0].currentrequirementYear
    }
    requiredItem.push(obj)
    this.year.selectedItems=requiredItem
    // for (var i = 0; i < this.year.selectedItems.length; i++) {
    //   this.selectedYear.push(this.year.selectedItems[i].text)
    // }
    this.dropdownyearSetting = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false,
      enableCheckAll: false
    };
  }

  GetMaterialAllocationScreen() {
    debugger;
    this.loader = 'block';
    if (this.roleID == '42' || this.roleID == '76')
      //  this.selectedRMHName = "'" + this.userID + "'";
      this.selectedRMHName =  this.userID ;
      
    else
    this.selectedRMHName = "'" + this.userID + "'";
      //this.selectedRMHName = this.selectedRMHName.lastIndexOf(",") == this.selectedRMHName.length - 1 ? this.selectedRMHName.substring(0, this.selectedRMHName.lastIndexOf(",")) : this.selectedRMHName;
    this.selectedMonth = this.selectedMonth.lastIndexOf(',') == this.selectedMonth.length - 1 ? this.selectedMonth.substring(0, this.selectedMonth.length - 1) : this.selectedMonth;
    this.selectedCrop = this.selectedCrop.lastIndexOf(",") == this.selectedCrop.length - 1 ? this.selectedCrop.substring(0, this.selectedCrop.length - 1) : this.selectedCrop;
    this.selectedBrand = this.selectedBrand.lastIndexOf(",") == this.selectedBrand.length - 1 ? this.selectedBrand.substring(0, this.selectedBrand.lastIndexOf(",")) : this.selectedBrand;
    this.selectedLanguage = this.selectedLanguage.lastIndexOf(",") == this.selectedLanguage.length - 1 ? this.selectedLanguage.substring(0, this.selectedLanguage.length - 1) : this.selectedLanguage;
    this.selectedJobType = this.selectedJobType.lastIndexOf(",") == this.selectedJobType.length - 1 ? this.selectedJobType.substring(0, this.selectedJobType.length - 1) : this.selectedJobType;
    // this.selectedJobNumber = Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return "'" + item.id + "'"; }).join(",");
    this.selectedJobNumber = Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return  item.id ; }).join(",");
    // this.selectedState = Array.prototype.map.call(this.State.selectedItems, function (item) { return "'" + item.id + "'"; }).join(",");
    this.selectedState = Array.prototype.map.call(this.State.selectedItems, function (item) { return  item.id ; }).join(",");
    // this.currentStatus = Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return "'" +item.text+ "'"; }).join(",");
      this.currentStatus = Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return item.text ; }).join(",");
   
   
    if (this.currentStatus.length == 0)
    {
      if(this.roleID != '76')
      {
        this.currentStatus = Array.prototype.map.call(this.dropdownStatus,function(item){return "'" +item.item_text+ "'"; }).join(",");   
      }
      
    }
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    debugger;

      this.mcPlanningMaterialService.materialAllocationDetails(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedMonth, this.selectedJobNumber, this.selectedState, this.currentStatus,this.selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          debugger;
          this.materialAllocationDetails = responseData.data;
          this.model = responseData.data;
          this.loader = 'none';
          this.selectCheck=false;
          this.confirmJobNumber='';
          // this.setPage(1, this.pageSetting)
        }
        else {
          this.materialAllocationDetails = responseData.data;
          this.toastr.error('No record Available');
          this.loader = 'none';
          this.selectCheck=false;
          this.confirmJobNumber='';
        }
      })
  }
  viewPanel(detail: any) {
    debugger;
    this.popRequirmentID = detail.requirementDetailsID;
    this.popJobNumber = detail.jobNumber;
    this.popRegion='';
    this.MaterialAllocation("SELECT", 0, false, false);
    this.displayEditPanel = 'block';
    this.displayViewPanel = 'none';
    
  }
  async viewEditPanel(detail: any) {
    debugger;
    this.popRequirmentID = detail.requirementDetailsID;
    this.popJobNumber = detail.jobNumber;
    this.popRequirementType = detail.requirementType;
    this.quantity=detail.finalQuantity;
    this.popRegion=detail.regioncode;
    debugger;
    this.MIEMDOuserDetail=this.materialAllocationFilters.userID.filter(m=>m.regionCode==detail.regioncode);
    if(this.MIEMDOuserDetail.length>0)
    {
      debugger;
    this.popUserID=this.MIEMDOuserDetail[0].userID  
    this.popDesg=this.MIEMDOuserDetail[0].roleName;  
    this.popName=this.MIEMDOuserDetail[0].name;
    }
    this.materialAllocation = [];

    if (detail.isSavedAsDraft == 0 && detail.isSubmitted==0) {
      this.displayEditPanel = 'block';
      this.displayViewPanel = 'block';
      this.popRMH = detail.rmhid;
      this.popEstDel = detail.deliveryDeadline;
      this.popState = detail.state;
      this.popLanguage = detail.languageID;
      this.popBrand = detail.brand;
      this.popJobType = detail.jobTypeID;
      this.popCrop = detail.cropID;
      // this.popFAQ = detail.finalQuantity;
      this.popAQty = 0;
      // this.popTotalremainingqty = detail.finalQuantity;
      // this.TotalRemainingQuantity = this.popTotalremainingqty;
      this.popStatus = detail.statusID;
      this.GetRegionDropdown(detail);
      await this.MaterialAllocation("GETSELECT", 0, false, false)

    }
    else {
      await this.MaterialAllocation("GETSELECT", 0, false, false)
      if (this.materialAllocation == null || this.materialAllocation.length == 0) {
        this.displayEditPanel = 'block';
        this.displayViewPanel = 'block';
        this.popRMH = detail.rmhid;
        this.popEstDel = detail.deliveryDeadline;
        this.popState = detail.state;//replace(/\s/g, "");
        this.popLanguage = detail.languageID;
        this.popBrand = detail.brand;
        this.popJobType = detail.jobTypeID;
        this.popCrop = detail.cropID;
        // this.popFAQ = detail.finalQuantity;
        // this.popName = '';
        // this.popUserID = '';
        // this.popDesg = '';
        this.popAQty = 0;
        this.popStatus = detail.statusID;//6;
        this.TotalRemainingQuantity = detail.finalQuantity;

        this.IsValidRole = false;

        this.materialAllocation = [];
        this.errorMessage = "";
        this.GetRegionDropdown(detail);

        
      }
    }
    const body = document. getElementsByTagName('body')[0];
    body.classList.add('overlay-back');
  }
  closeEditPanel() {
    this.displayEditPanel = 'none';
    this.TotalRemainingQuantity = 0;
    this.popTotalremainingqty = 0;
    this.materialAllocation = [];
    this.popRegion='';
    this.hdnLimit = true;
    this.MIEMDOuserDetail=[];
    this.applySearchFilter();
    const body = document. getElementsByTagName('body')[0];
    body.classList.remove('overlay-back');
  }
  AllocateQuantity(event: any) {
    if (Number(event.currentTarget.value) < 0) {
      event.currentTarget.value = "0";
    }
    else {
      if (this.popFAQ >= this.popAQty) {
        this.hdnLimit = true;
        if (this.TotalRemainingQuantity - this.popAQty >= 0) {
          this.popTotalremainingqty = this.TotalRemainingQuantity - this.popAQty;
        }
        else {
          this.hdnLimit = false;
          this.errorMessage = "Allocated quantity exceed its limit";
        }

      }
      else {
        this.hdnLimit = false;
        this.errorMessage = "Allocated quantity exceed its limit";
      }
    }
  }
  async DraftSave() {
    if (this.TotalRemainingQuantity >= 0 && this.popAQty > 0 && this.TotalRemainingQuantity - this.popAQty >= 0 && this.popName != undefined && this.popName !='') {
      await this.MaterialAllocation("INSERT", 0, true, false);   

    }
    else {
      this.toastr.error('Required fields can not be blank');
    }
  }
  async AllocationSubmit() {

      if (this.TotalRemainingQuantity >= 0  && this.TotalRemainingQuantity - this.popAQty >= 0 && this.popName != undefined  && this.popName !='') {
        this.displayViewPanel = "none";
        const body = document. getElementsByTagName('body')[0];
        body.classList.add('overlay-back');
        await this.MaterialAllocation("SUBMIT", 0, false, true);
        //await this.MaterialAllocation("GETSELECT", 0, false, true);

      }
    
    else {
      this.toastr.error('Required fields can not be blank');
    }
  

  }
  async DeleteAllocation(details: any) {
    await this.MaterialAllocation("DELETE", details.allocateID, false, false);
  }
  MaterialAllocation(Defination: string, AllotedId: number, IsSaveAsDraft: boolean, isSubmitted: boolean): Promise<any> {
    this.mcPlanningMaterialService.SavematerialAllocationDetails(Defination, AllotedId, this.popRequirmentID, this.popJobNumber, this.popUserID, this.popDesg, this.popName, this.popFAQ, this.popAQty, this.popTotalremainingqty, IsSaveAsDraft, isSubmitted, this.popRequirementType,this.popRegion)
      .subscribe((responseData: any) => {        
        if (responseData.status == true) {
          this.materialAllocation = [];
          this.materialAllocation = responseData.data;       
            this.popTotalremainingqty = responseData.data[0]["totalRemaining"];
            this.TotalRemainingQuantity = responseData.data[0]["totalRemaining"];
          this.popAQty = 0;
          this.loader = 'none';
        }
        else {    
          this.materialAllocation = [];
          this.popTotalremainingqty = this.quantity;
          this.TotalRemainingQuantity = this.quantity;
          this.popAQty = 0;         
          this.loader = 'none';
          this.displayViewPanel='block';
         // this.toastr.error('No record available/Could not submit records,Please check the inputs', 'Close', 'red-snackbar');
        }
      })
    return;
  }
  GetRegionDropdown(detail: any) {
    this.mcPlanningMaterialService.GetMaterialAllocationRegion(this.popJobNumber)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          let countregion = 0;
          this.Region = [];
          this.Region = responseData.data;
          countregion = this.Region.length;
          if (countregion > 0) {
            this.popRegion = detail.regioncode;//this.Region[0].regionCode;
            this.changeRegionFAQ = this.Region.find(m => m.regionCode == detail.regioncode).approvedQuantity;  //Math.floor(detail.finalQuantity/countregion);
            this.popFAQ = this.Region.find(m => m.regionCode == detail.regioncode).approvedQuantity;//Math.floor(detail.finalQuantity/countregion);
            this.popTotalremainingqty = this.Region.find(m => m.regionCode == detail.regioncode).totalRemaining;
            if (detail.isSavedAsDraft == 0 && detail.isSubmitted == 0) {
              this.TotalRemainingQuantity = this.Region.find(m => m.regionCode == detail.regioncode).totalRemaining;//Math.floor(detail.finalQuantity/countregion);
              this.popTotalremainingqty = this.Region.find(m => m.regionCode == detail.regioncode).totalRemaining;//Math.floor(detail.finalQuantity/countregion);
              this.quantity = this.changeRegionFAQ;
            }
            else {
              this.TotalRemainingQuantity = this.Region.find(m => m.regionCode == detail.regioncode).totalRemaining;//Math.floor(detail.finalQuantity/countregion);
              this.popTotalremainingqty = this.Region.find(m => m.regionCode == detail.regioncode).totalRemaining;//Math.floor(detail.finalQuantity/countregion);
              this.quantity = this.changeRegionFAQ;
            }
          
          }

          else {
            this.toastr.error('No Region code Found');
          }


        }
        else {
          this.popRegion = '';
          this.loader = 'none';
          // this.toastr.error('Some Error Occured/Due Date Exceeds,Could Not Submit Records', 'Close', 'red-snackbar');
        }
      })
    return;
      
    }
    changeRegion(countregion:number)
    {
      if(countregion>0)
      {
      this.popFAQ=this.Region.find(m=>m.regionCode==this.popRegion).approvedQuantity;//this.changeRegionFAQ;
      this.TotalRemainingQuantity=this.Region.find(m=>m.regionCode==this.popRegion).approvedQuantity;
      this.popTotalremainingqty=this.Region.find(m=>m.regionCode==this.popRegion).approvedQuantity;
      this.quantity=this.Region.find(m=>m.regionCode==this.popRegion).approvedQuantity;

      }
      this.MIEMDOuserDetail=[];
      this.MIEMDOuserDetail=this.materialAllocationFilters.userID.filter(m=>m.regionCode==this.popRegion);
      if(this.MIEMDOuserDetail.length>0)
      {
      this.popUserID=this.MIEMDOuserDetail[0].userID  
      this.popDesg=this.MIEMDOuserDetail[0].roleName;  
      this.popName=this.MIEMDOuserDetail[0].name;
      }
      this.MaterialAllocation("GETSELECT", 0, false, false);
      
    }
  changeName(details: any) {
    debugger;
    this.popDesg = details.find(m => m.name == this.popName).roleName;
    this.popUserID = details.find(m => m.name == this.popName).userID;
  }
  excelDownload() {
    this.loader = 'block';
    this.selectedMonth = this.selectedMonth.lastIndexOf(',') == this.selectedMonth.length - 1 ? this.selectedMonth.substring(0, this.selectedMonth.length - 1) : this.selectedMonth;
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.DownloadmaterialAllocationExcel(this.selectedMonth,this.selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          //let roleId=localStorage.getItem('mcmt_roleID');
          var date = new Date();
          var latest_date = this.datePipe.transform(date, 'dd-MMM-yy');
          var Name = localStorage.getItem('mcmt_userName').split(' ');
          var Firstname = Name[0];
          var LastName = Name[1];
          let cYear = this.year.selectedItems[0].id;
          var ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_MaterialAllocation_' + latest_date + '.xlsx';
          // let ExcelName =this.userID+'_MaterialAllocation_' + date.getDate() + '_' + date.getMonth() + '_' + date.getUTCFullYear() + '.xlsx';
          if (success.size > 0)
            saveAs(success, ExcelName);
          else
            this.toastr.error("No Records Available.");
          this.loader = 'none';
        },
        err => {
          this.toastr.error("No Records Available.");
          this.loader = 'none';
          console.log(err);
        }
      );
  }

  filesDroppedAdd(files: File[]) {
      this.loader = 'block';
      this.files = [];
      this.files = files;
      let fileNameParts: string[] = files[0].name.split('.');
      let fileType = files[0].name.split('.')[fileNameParts.length - 1];
      let CorrectFileName = 'MaterialAllocation'
      //console.log(fileNameParts[0].includes(CorrectFileName));
      if (fileNameParts[0].includes(CorrectFileName)) {
        this.IsFileCorrect = true;
      }
      else {
        this.IsFileCorrect = false;
      }
      if (this.IsFileCorrect == false) {
        this.toastr.error('Please Select Valid File.');
        this.loader = 'none';
        return false;
      }
      if (fileType != 'xls' && fileType != 'xlsx') {
        this.toastr.error('Please Select Valid File Type.');
        this.loader = 'none';
        return false;
      }
      else {
        this.loader = 'block';
        this.document.file = <File>this.files[0];
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(<File>this.files[0]);
        fileReader.onload = (e) => {
          this.arrayBuffer = fileReader.result;
          var data = new Uint8Array(this.arrayBuffer);
          var arr = new Array();
          for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          var bstr = arr.join("");
          var workbook = XLSX.read(bstr, { type: "binary" });
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          this.displayUploadPanel = 'block';
          this.files = [];
          this.loader = 'none';
        }
      }
    
  }
  closeUploadPanel() {
    this.displayUploadPanel = 'none';
    this.errorExcelUpload = null;
    //window.location.reload();
  }
  UploadSubmit() {
    this.loader = 'block';
    this.mcPlanningMaterialService.UploadmaterialAllocationExcel(this.filelist).subscribe((responseData: any) => {
      if (responseData.message == 'Successful!') //responseData.status = 'OK' &&
      {
        this.toastr.success('File Uploaded Successfully');
        this.loader = 'none';
        this.displayUploadPanel = 'none';
        this.GetMaterialAllocationScreen();
        
      }
      else if (responseData.message == "Error in excel!")//responseData.status = 'OK' && 
      {
        this.toastr.error('Invalid excel data,Please correct the excel data');
        this.loader = 'none';
        this.filelist = null;
        this.errorExcelUpload = responseData.data;
        this.displayUploadPanel = 'block';
      }
      else {
        this.toastr.error('Some error occured while uploading file');
        this.loader = 'none';
        this.displayUploadPanel = 'none';
      }
    });


    // err=>{
    //   this.toastr.error('Some error occured while uploading file', 'Close', 'red-snackbar');
    //   this.loader = 'none';
    //   this.displayUploadPanel = 'none';
  }
  ConfirmReceipt() {
    if ( this.confirmJobNumber != "" && this.confirmJobNumber != ",") {
      // this.confirmRequirementId = "";
      // this.materialAllocationDetails.forEach(element => {
      //  // if(element.status=='Material dispatched to Field team')
      //   this.confirmRequirementId += element.isSelected == undefined || element.isSelected == false ? "" :"'"+ element.requirementDetailsID + "'"+",";
      // });
      this.mcPlanningMaterialService.SavematerialAllocationDetails('CONFIRM', 0, 0, this.confirmJobNumber, '', '', this.confirmRequirementId, 0, 0, 0, false, false, this.popRequirementType,this.popRegion)
        .subscribe((responseData: any) => {
          if (responseData.status == true) {
            this.loader = 'none';
            this.toastr.success("Receipt Confirmation Updated Succesfuliy");
            this.GetMaterialAllocationScreen();
          }
          else {
            this.toastr.error("No records Updated");
            this.loader = 'none';
          }
        })

      }
      else
      this.toastr.error("No records selected");

    //}
  }

   SelectAllConfirmation() {
    this.materialAllocationDetails.forEach(element => {
      if (this.selectCheck == true)
      {
        if(element.status=='Field Team Confirmation Pending')
        {
        element.isSelected = true;
        if(this.confirmJobNumber.indexOf(element.jobNumber)==-1)
        this.confirmJobNumber +=element.jobNumber+',';
      }
      }
      else {
        if(element.status=='Field Team Confirmation Pending')
        element.isSelected = false;
        this.confirmJobNumber='';
      }
    })
  }
  checkSelect(index: number) {
    if (this.materialAllocationDetails[index]["isSelected"]) {
      // if(this.confirmRequirementId.length>0)
      this.confirmRequirementId += this.materialAllocationDetails[index]["requirementDetailsID"]+',';
      if(this.confirmJobNumber.indexOf(this.materialAllocationDetails[index]["jobNumber"])==-1)
      this.confirmJobNumber += this.materialAllocationDetails[index]["jobNumber"]+',';
      //this.ConfirmReceipt();
      // this.confirmRequirementId.trim().replace(this.materialAllocationDetails[index]["requirementDetailsID"] + ',', '');
      // this.selectCheck = false;
    }
    else{
      if(this.confirmJobNumber.split(",").length==1)
      this.confirmJobNumber=this.confirmJobNumber.replace(this.materialAllocationDetails[index]["jobNumber"],"")
      else
      if(this.confirmJobNumber.indexOf(this.materialAllocationDetails[index]["jobNumber"])!=-1)
      {
      this.confirmJobNumber=this.confirmJobNumber.replace(","+this.materialAllocationDetails[index]["jobNumber"],"")
      if(this.confirmJobNumber.indexOf(this.materialAllocationDetails[index]["jobNumber"])!=-1)
      {
        this.confirmJobNumber=this.confirmJobNumber.replace(this.materialAllocationDetails[index]["jobNumber"],"")
      }
      }

      this.selectCheck=false;
    }
  }
  sort() {
    let sortedArray : any[] = [];
    let splitString : any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownMonth.forEach(x => {
        this.materialAllocationDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.materialAllocationDetails = sortedArray;
    }
    else {
      this.dropdownMonth.forEach(x => {
        this.materialAllocationDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.materialAllocationDetails = sortedArray.reverse();
    }
  }

  ConvertToCurrency(value:any)
  {
    if (typeof value === "undefined")
    {
        value='0';
    }
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}

